import { Box, Typography } from '@mui/material';
import { BaseButton } from '../../base';
import {useTheme} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import URIs from '../../../utils/uri';
import { numberToTomans } from '../../../utils/helpers';

const ProductRow = ({item}) => {
    const theme = useTheme();
    const navigate = useNavigate();
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '10px 10px',
                borderRadius: '4px',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '30%',
                    gap: '8px'
                }}
            >
                <BaseButton
                    disabled={!item.buyPrice || !item.buyActive}
                    onClick={()=>{
                        navigate(URIs.ORDER, { state: { orderType: 'buy', productId: item.productId, productType: item.productType, productName: item.productName } })
                    }}
                    sx={{
                        borderRadius: '50px',
                        width: '100%',
                        height: '40px',
                        border: '1px solid',
                        borderColor: theme.palette.success.main,
                        backgroundColor: theme.palette.background.dark,
                    }}
                >
                    <Typography
                        variant='caption2'
                        sx={{ 
                            display: 'flex',
                            flexDirection: 'row',
                            flex: 1,
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                            color: theme.palette.success.main
                        }}
                    >
                        {numberToTomans(item.buyPrice)}
                    </Typography>
                </BaseButton>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '30%',
                    gap: '8px'
                }}
            >
                <Typography
                    variant='subtitle'
                    color='textSecondary'
                    align="center"
                    sx={{ display: 'flex', flexDirection: 'row', flex: 1, alignItems: 'center', justifyContent: 'center', width: '100%'}}
                >
                    {item.productName}
                </Typography>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '30%',
                    gap: '8px'
                }}
            >
                <BaseButton
                    disabled={!item.sellPrice || !item.sellActive}
                    onClick={()=>{
                        navigate(URIs.ORDER, { state: { orderType: 'sell', productId: item.productId, productType: item.productType, productName: item.productName } })
                    }}
                    sx={{
                        borderRadius: '50px',
                        width: '100%',
                        height: '40px',
                        border: '1px solid',
                        borderColor: theme.palette.error.main,
                        backgroundColor: theme.palette.background.dark,
                    }}
                >
                    <Typography
                        variant='caption2'
                        sx={{ 
                            display: 'flex',
                            flexDirection: 'row',
                            flex: 1,
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                            color: theme.palette.error.main
                        }}
                    >
                        {numberToTomans(item.sellPrice)}
                    </Typography>
                </BaseButton>
            </Box>
        </Box>
    );
};

export default ProductRow;
